/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useMemo, useRef, useEffect} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import TokenVerification, {submitTokenFormProps} from './RegistrationSteps/TokenVerification'
import GeneralInformation, {
  submitGeneralInformationFormProps,
} from './RegistrationSteps/GeneralInformation'
import Completed from './RegistrationSteps/Completed'
import ClassInformation, {
  submitClassInformationFormProps,
} from './RegistrationSteps/ClassInformation'
import PersonalInformation, {
  submitPersonalInformationFormProps,
} from './RegistrationSteps/PersonalInformation'
import {useIntl} from 'react-intl'
import {Spinner} from 'react-bootstrap'
import useAuth from '../../../../hooks/useAuth'
import axios, {AxiosError} from 'axios'
import {RegisterUserRequest} from '../../../../redux/reducers/auth/types'
import useEstablishements from '../../../../hooks/useEstablishements'
import useClasses from '../../../../hooks/useClasses'
import useSubjects from '../../../../hooks/useSubjects'
export function Registration() {
  const {fetchAllEstablishements} = useEstablishements()
  const {fetchAllClasses} = useClasses()
  const {fetchAllSubjects} = useSubjects()

  useEffect(() => {
    fetchAllClasses({isFinished: false})
    fetchAllEstablishements({})
    fetchAllSubjects({})
  }, [])

  const intl = useIntl()
  const [isLoading, setIsLoading] = useState(false)
  const {actionLoading} = useAuth()

  const setLoading = (value: boolean) => {
    setIsLoading(value)
  }
  const [step, setStep] = useState(1)
  const {lastStep, initStep} = useMemo(() => {
    return {initStep: 1, lastStep: 5}
  }, [])

  const nextStep = () => {
    setStep(step + 1)
  }

  const prevStep = () => {
    setStep(step - 1)
  }

  const initUser: RegisterUserRequest = {
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    birthDay: '',
    placeOfBirth: '',
    location: '',
    governorate: '',
    zipCode: '',
    phone: '',
    classrooms: [],
    establishements: [],
    subjects: [],
    token: '',
    password: '',
    gender: '',
  }

  const [data, setData] = useState<RegisterUserRequest>(initUser)
  const onSubmitToken = ({token, role}: submitTokenFormProps) => {
    setData({...data, token, role})
    nextStep()
  }
  const onSubmitGeneralInformation = (values: submitGeneralInformationFormProps) => {
    setData({...data, ...values})
    nextStep()
  }

  const onSubmitPersonalInformation = (values: submitPersonalInformationFormProps) => {
    setData({...data, ...values})
    nextStep()
  }

  const [error, setError] = useState('')
  const onSubmitClassInformation = async (values: submitClassInformationFormProps) => {
    try {
      const request = {...data, ...values}
      setData({...request})
      const API_URL = process.env.REACT_APP_API_URL
      setLoading(true)
      await axios.post(`${API_URL}/api/auth/register`, request)
      setLoading(false)
      setError('')
      nextStep()
    } catch (error) {
      const err = error as AxiosError
      const message: any = err.response?.data
      setError(message[intl.locale])
      setLoading(false)
    }
  }
  const submitBtnRef = useRef<HTMLButtonElement>(null)
  const onSubmitClick = () => {
    if (submitBtnRef && submitBtnRef.current) {
      submitBtnRef.current.click()
    }
  }

  return (
    <div className='_registration stepper stepper-pills stepper-column  d-flex flex-column gap-10 flex-xl-row flex-row-fluid'>
      <div className='_header d-flex p-8 justify-content-center bg-white rounded justify-content-xl-start flex-row-auto'>
        <div className=''>
          <div className='stepper-nav'>
            <div
              className={`stepper-item ${step === 1 ? 'current' : ''} ${
                step > 1 ? 'completed' : ''
              }`}
              data-kt-stepper-element='nav'
            >
              <div className='stepper-line w-40px'></div>

              <div className='stepper-icon w-40px h-40px'>
                <i className='stepper-check fas fa-check'></i>
                <span className='stepper-number'>1</span>
              </div>

              <div className='stepper-label'>
                <h3 className='stepper-title'>
                  {intl.formatMessage({id: 'MENU.TOKEN_VERIFICATION'})}
                </h3>
              </div>
            </div>

            <div
              className={`stepper-item ${step === 2 ? 'current' : ''} ${
                step > 2 ? 'completed' : ''
              }`}
              data-kt-stepper-element='nav'
            >
              <div className='stepper-line w-40px'></div>

              <div className='stepper-icon w-40px h-40px'>
                <i className='stepper-check fas fa-check'></i>
                <span className='stepper-number'>2</span>
              </div>

              <div className='stepper-label'>
                <h3 className='stepper-title'>
                  {intl.formatMessage({id: 'MENU.GENERAL_INFORMATION'})}
                </h3>
              </div>
            </div>
            <div
              className={`stepper-item ${step === 3 ? 'current' : ''} ${
                step > 3 ? 'completed' : ''
              }`}
              data-kt-stepper-element='nav'
            >
              <div className='stepper-line w-40px'></div>

              <div className='stepper-icon w-40px h-40px'>
                <i className='stepper-check fas fa-check'></i>
                <span className='stepper-number'>3</span>
              </div>

              <div className='stepper-label'>
                <h3 className='stepper-title'>
                  {intl.formatMessage({id: 'MENU.PERSONAL_INFORMATION'})}
                </h3>
              </div>
            </div>

            <div
              className={`stepper-item ${step === 4 ? 'current' : ''} ${
                step > 4 ? 'completed' : ''
              }`}
              data-kt-stepper-element='nav'
            >
              <div className='stepper-line w-40px'></div>

              <div className='stepper-icon w-40px h-40px'>
                <i className='stepper-check fas fa-check'></i>
                <span className='stepper-number'>4</span>
              </div>

              <div className='stepper-label'>
                <h3 className='stepper-title'>
                  {intl.formatMessage({id: 'MENU.CLASS_INFORMATION'})}
                </h3>
              </div>
            </div>

            <div
              className={`stepper-item  ${step >= 5 ? 'completed' : ''}`}
              data-kt-stepper-element='nav'
            >
              <div className='stepper-line w-40px'></div>

              <div className='stepper-icon w-40px h-40px'>
                <i className='stepper-check fas fa-check'></i>
                <span className='stepper-number'>5</span>
              </div>

              <div className='stepper-label'>
                <h3 className='stepper-title'>{intl.formatMessage({id: 'MENU.COMPLETED'})}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='_content d-flex flex-row-fluid flex-column flex-center bg-white rounded p-8 _content'>
        <div className='current'>
          {step === 1 ? (
            <TokenVerification
              user={data}
              onSubmit={onSubmitToken}
              btnRef={submitBtnRef}
              setLoading={setLoading}
            />
          ) : step === 2 ? (
            <GeneralInformation
              user={data}
              onSubmit={onSubmitGeneralInformation}
              btnRef={submitBtnRef}
              setLoading={setLoading}
            />
          ) : step === 3 ? (
            <PersonalInformation
              onSubmit={onSubmitPersonalInformation}
              btnRef={submitBtnRef}
              user={data}
            />
          ) : step === 4 ? (
            <ClassInformation
              onSubmit={onSubmitClassInformation}
              btnRef={submitBtnRef}
              user={data}
              error={error}
            />
          ) : (
            <Completed email={data.email} />
          )}
        </div>

        {step < lastStep ? (
          <div className='d-flex align-self-end justify-content-end gap-2 pt-10'>
            {isLoading || actionLoading ? (
              <button className='btn btn-primary btn-lg fw-bolder me-4'>
                <Spinner role='status' animation='border' />
              </button>
            ) : (
              <>
                {step > 2 && (
                  <button onClick={prevStep} type='button' className='btn btn-lg btn-light me-3'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-4 me-1'
                    />
                    {intl.formatMessage({id: 'MENU.BACK'})}
                  </button>
                )}
                <button onClick={onSubmitClick} className='btn btn-lg btn-primary me-3'>
                  <span className='indicator-label'>
                    {step < 4 && intl.formatMessage({id: 'MENU.CONTINUE'})}
                    {step === 4 && intl.formatMessage({id: 'MENU.SUBMIT'})}
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-2 me-0'
                    />
                  </span>
                </button>
              </>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
